module.exports = __webpack_public_path__ + "img/profile_pic.b9d5869f.png";